import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { Badge, Collapse } from "reactstrap";
import * as myConstClass from "../constant.js";
import IosPulse from "react-ionicons/lib/IosPulse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import routes from "../routes/index";
import "./logo.scss";
import {
  Translator,
  T,
  TF,
  LanguageList,
  Config,
} from "react-translator-component";

// import avatar from "../assets/img/avatars/avatar.jpg";
// const avatar = `http://localhost/workzone/backend/img/profile.png`;
// const logo = `http://localhost/workzone/backend/img/clock_new.png`;
// const zone_logo = `http://localhost/workzone/backend/img/Work-Zone-Plus-logo.png`;

// const avatar = `https://alpha.workzoneplus.com/backend/img/profile.png`;
// const logo = `https://alpha.workzoneplus.com/backend/img/clock_new.png`;
// const zone_logo = `https://alpha.workzoneplus.com/backend/img/Work-Zone-Plus-logo.png`;

// const logo = `https://beta.workzoneplus.com/backend/img/clock_new.png`;
const logo = myConstClass.SITE_URL + `img/Workzonebusiness.png`;
let lastScrollTop = 0;
//localStorage.clear("lang");
Config.default = localStorage.getItem("lang");


const SidebarCategory = withRouter(
  ({
    name,
    badgeColor,
    badgeText,
    icon,
    isOpen,
    children,
    onClick,
    location,
    to,
  }) => {
    const getSidebarItemClass = (path) => {
      return location.pathname.indexOf(path) !== -1 || location.pathname === "/"
        ? "active"
        : "";
    };

    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Store scroll position and element before click
      const sidebar = document.querySelector("#vertical_scroll_sidebar");
      const clickedItem = e.currentTarget.closest('.sidebar-item');
      
      if (sidebar) {
        sidebar.dataset.scrollTop = sidebar.scrollTop;
        sidebar.dataset.preventScrollReset = 'true';
        
        // Store the clicked element's position
        if (clickedItem) {
          sidebar.dataset.menuItemTop = clickedItem.offsetTop;
        }
      }
      
      onClick(e);
    };

    return (
      <li className={"sidebar-item " + getSidebarItemClass(to)}>
        <span
          data-toggle="collapse"
          className={"sidebar-link " + (!isOpen ? "collapsed" : "")}
          onClick={handleClick}
          aria-expanded={isOpen ? "true" : "false"}
        >
          <FontAwesomeIcon
            icon={icon}
            fixedWidth
            className="align-middle mr-2"
          />{" "}
          <span className="align-middle">{name}</span>
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} pill className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </span>
        <Collapse 
          isOpen={isOpen}
          onEntering={() => {
            // Prevent scroll reset when collapse opens
            const sidebar = document.querySelector("#vertical_scroll_sidebar");
            if (sidebar && sidebar.dataset.scrollTop) {
              const savedScroll = parseInt(sidebar.dataset.scrollTop, 10);
              sidebar.scrollTop = savedScroll;
            }
          }}
          onEntered={() => {
            // Restore scroll after collapse animation completes
            const sidebar = document.querySelector("#vertical_scroll_sidebar");
            if (sidebar && sidebar.dataset.scrollTop) {
              const savedScroll = parseInt(sidebar.dataset.scrollTop, 10);
              sidebar.scrollTop = savedScroll;
            }
          }}
        >
          <ul id="item" className={"sidebar-dropdown list-unstyled"}>
            {children}
          </ul>
        </Collapse>
      </li>
    );
  }
);

const SidebarItem = withRouter(
  ({ name, badgeColor, badgeText, icon, location, to }) => {
    const getSidebarItemClass = (path) => {
      return location.pathname === path ? "active" : "";
    };

    return (
      <li className={"sidebar-item " + getSidebarItemClass(to)}>
        <NavLink to={to} className="sidebar-link" activeClassName="active">
          {icon ? (
            <React.Fragment>
              <FontAwesomeIcon
                icon={icon}
                fixedWidth
                className="align-middle mr-2"
              />{" "}
              <span className="align-middle">{name}</span>
            </React.Fragment>
          ) : (
            name
          )}{" "}
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} pill className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </NavLink>
      </li>
    );
  }
);

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state = {
      empData: [],
      user_id: "",
    };
    this.sidebarRef = React.createRef();
    this.scrollPosition = 0;
  }

  toggle = (index, event) => {
    // Get scroll position from dataset if available (set by SidebarCategory)
    const scroller = this.sidebarRef.current || document.querySelector("#vertical_scroll_sidebar");
    let currentScrollTop = 0;
    
    if (scroller) {
      // Try to get from dataset first (set by SidebarCategory click handler)
      currentScrollTop = scroller.dataset.scrollTop 
        ? parseInt(scroller.dataset.scrollTop, 10) 
        : scroller.scrollTop;
      this.scrollPosition = currentScrollTop;
    }
    
    // Get clicked element and its position
    let clickedElement = null;
    let menuItemOffsetTop = null;
    if (event && event.currentTarget) {
      clickedElement = event.currentTarget.closest('.sidebar-item');
      if (clickedElement && scroller) {
        // Calculate offset relative to scroll container
        const containerRect = scroller.getBoundingClientRect();
        const itemRect = clickedElement.getBoundingClientRect();
        menuItemOffsetTop = clickedElement.offsetTop;
      }
    }
    
    var login_id = localStorage.getItem("login_id");
    var login_type = localStorage.getItem("login_type");
    var pro_package = localStorage.getItem("package");
    var is_super_user = localStorage.getItem("is_super_user");
    this.state.pro_package = pro_package;

    var pro_zone_logo_logo;
    if (pro_package == "1") {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Pro-logo11.png`;
      $("#pro_logo").attr("src", pro_zone_logo_logo);
    } else {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Plus-logo.png`;
      $("#pro_logo").attr("src", pro_zone_logo_logo);
    }

    if (
      (login_type == "hr_admin" && is_super_user == "0") ||
      login_type == "super_admin"
    ) {
      fetch(myConstClass.BASE_URL + "user/getProfileInfo/" + login_id)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.setState({ empData: response });
        })
        .catch((err) => console.log(err));
    } else if (login_type == "sub_admin" && is_super_user != "0") {
      fetch(
        myConstClass.BASE_URL + "user/getSuperAdminStaffInfo/" + is_super_user
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.setState({ empData: response });
        })
        .catch((err) => console.log(err));
    } else {
      fetch(myConstClass.BASE_URL + "user/getUserInfoE/" + login_id)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.setState({ empData: response });
        })
        .catch((err) => console.log(err));
    }

    Object.keys(this.state).forEach(
      (item) =>
        this.state[index] ||
        this.setState(() => ({
          [item]: false,
        }))
    );

    // Toggle selected element
    const willOpen = !this.state[index];
    
    // Update state
    this.setState((state) => ({
      [index]: !state[index],
    }), () => {
      // After state update, restore scroll and scroll menu into view
      this.restoreScrollAndScrollToMenu(index, willOpen, menuItemOffsetTop, clickedElement);
    });
  };

  restoreScrollAndScrollToMenu = (index, willOpen, menuItemOffsetTop, clickedElement) => {
    const sidebarScroller = this.sidebarRef.current || document.querySelector("#vertical_scroll_sidebar");
    if (!sidebarScroller) return;
    
    // Get saved scroll position from dataset
    const savedScrollTop = sidebarScroller.dataset.scrollTop 
      ? parseInt(sidebarScroller.dataset.scrollTop, 10) 
      : this.scrollPosition;
    
    // Immediately restore scroll position (before any animations)
    sidebarScroller.scrollTop = savedScrollTop;
    this.scrollPosition = savedScrollTop;
    
    // Use multiple timeouts to catch scroll resets at different stages
    const restoreScroll = () => {
      if (sidebarScroller && savedScrollTop !== undefined) {
        sidebarScroller.scrollTop = savedScrollTop;
      }
    };
    
    // Restore immediately and at multiple intervals
    restoreScroll();
    setTimeout(restoreScroll, 10);
    setTimeout(restoreScroll, 50);
    setTimeout(restoreScroll, 100);
    setTimeout(restoreScroll, 200);
    setTimeout(restoreScroll, 300);
    
    // If opening a menu, scroll the menu item into view
    if (willOpen) {
      setTimeout(() => {
        const scroller = this.sidebarRef.current || document.querySelector("#vertical_scroll_sidebar");
        if (!scroller) return;
        
        // Restore scroll one more time
        scroller.scrollTop = savedScrollTop;
        
        let targetElement = clickedElement;
        let targetOffsetTop = menuItemOffsetTop || (scroller.dataset.menuItemTop ? parseInt(scroller.dataset.menuItemTop, 10) : null);
        
        // If element not found, try to find by index
        if (!targetElement || !scroller.contains(targetElement)) {
          const sidebarNav = scroller.querySelector('.sidebar-nav');
          if (sidebarNav) {
            const allMenuItems = Array.from(sidebarNav.children).filter(
              child => child.classList.contains('sidebar-item')
            );
            if (allMenuItems[index]) {
              targetElement = allMenuItems[index];
              targetOffsetTop = targetElement.offsetTop;
            }
          }
        }
        
        if (targetElement && targetOffsetTop !== null && targetOffsetTop !== undefined) {
          const sidebarHeight = scroller.clientHeight;
          const currentScroll = scroller.scrollTop;
          const itemHeight = targetElement.offsetHeight || 50;
          
          // Check visibility
          const itemTop = targetOffsetTop;
          const itemBottom = itemTop + itemHeight;
          const viewportTop = currentScroll;
          const viewportBottom = currentScroll + sidebarHeight;
          
          const isFullyVisible = itemTop >= viewportTop && itemBottom <= viewportBottom;
          
          if (!isFullyVisible) {
            // Scroll to show the menu item
            let scrollToPosition;
            if (itemTop < viewportTop) {
              scrollToPosition = Math.max(0, itemTop - 20);
            } else {
              scrollToPosition = Math.max(0, itemBottom - sidebarHeight + 20);
            }
            
            scroller.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth'
            });
          }
        }
        
        // Clean up dataset
        delete scroller.dataset.scrollTop;
        delete scroller.dataset.preventScrollReset;
        delete scroller.dataset.menuItemTop;
      }, 350);
    } else {
      // Clean up dataset
      setTimeout(() => {
        const scroller = this.sidebarRef.current || document.querySelector("#vertical_scroll_sidebar");
        if (scroller) {
          delete scroller.dataset.scrollTop;
          delete scroller.dataset.preventScrollReset;
          delete scroller.dataset.menuItemTop;
        }
      }, 200);
    }
  };

  componentWillMount() {
    var pro_package = localStorage.getItem("package");
    this.state.pro_package = pro_package;
    //var pro_package= localStorage.getItem('package');
    // var is_super_user= localStorage.getItem('is_super_user');
    // this.state.pro_package = pro_package;
    //alert(TF("{0}",T("Language")));

    var pro_zone_logo_logo;
    if (pro_package == "1") {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Pro-logo11.png`;
      $("#pro_logo").attr("src", pro_zone_logo_logo);
    } else {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Plus-logo.png`;
      $("#pro_logo").attr("src", pro_zone_logo_logo);
    }
    // alert('hii');
    let ten_path;
    var url = window.location.pathname;

    var str = url.split("/");
    ten_path = "/" + str[1] + "/" + str[2];
    //alert(ten_path+'/guests');
    /* Open collapse element that matches current url */
    const pathName = this.props.location.pathname;
    // alert(pathName);

    routes.forEach((route, index) => {
      //  route.chidren;

      //  alert(route);
      //    alert(route.open);

      route.name = T(route.name);

      if (route.path == ten_path + "/guests") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("guests") > -1 ||
          pathName.indexOf("incident") > -1
        ) {
          //if(pathName==ten_path+'/guests/*' || pathName==ten_path+'/incident/*')
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, // || isHome
          }));
        }
      }
      // alert(route.path);

      if (route.path == ten_path + "/employees") {
        //alert('hii');
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }

        if (
          (pathName.indexOf("employee") > -1 &&
            pathName.indexOf("employeeEvalution") != 1) ||
          pathName.indexOf("complaints") > -1 ||
          pathName.indexOf("admin_staff") > -1
        ) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          //const isHome = route.containsHome && pathName === "/" ? true : false;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/settings") {
        // alert('hii');
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }

        if (
          pathName.indexOf("settingsorganization") > -1 ||
          pathName.indexOf("settingspayrollheaders") > -1 ||
          pathName.indexOf("settingsdepartment") > -1 ||
          pathName.indexOf("settingsholidays") > -1 ||
          pathName.indexOf("settingspoints") > -1 ||
          pathName.indexOf("settingssaroles") > -1 ||
          pathName.indexOf("settingsleave_type") > -1 ||
          pathName.indexOf("settingsadminapp") > -1 ||
          pathName.indexOf("settingsassets") > -1 ||
          pathName.indexOf("settingsallownce_type") > -1 ||
          pathName.indexOf("settingsallownce_code") > -1 ||
          pathName.indexOf("settingsnote_code") > -1 ||
          pathName.indexOf("settingsdocument_type") > -1 ||
          pathName.indexOf("settingsemployee_groups") > -1 ||
          pathName.indexOf("settingsblog_type") > -1 ||
          pathName.indexOf("settingsc_type") > -1 ||
          pathName.indexOf("settingsannoucement_type") > -1 ||
          pathName.indexOf("settingsnoticepaycheck") > -1 ||
          pathName.indexOf("settingspayrollPrivilege") > -1 ||
          pathName.indexOf("settingscategory_type") > -1 ||
          pathName.indexOf("settingscomplaint_type") > -1 ||
          pathName.indexOf("settings_groups") > -1 ||
          pathName.indexOf("settingspayrollPrivilege") > -1 ||
          pathName.indexOf("settingscategory") > -1 ||
          pathName.indexOf("settingssubcategory") > -1 ||
          pathName.indexOf("settingsbank") > -1 ||
          pathName.indexOf("settingshrfields") > -1 ||
          pathName.indexOf("settingsactivitytype") > -1 ||
          pathName.indexOf("settingsactivitystatus") > -1 ||
          pathName.indexOf("settingsactivityevalution") > -1 ||
          pathName.indexOf("settingsattendansevalution") > -1 ||
          pathName.indexOf("settingsticketcategory") > -1
        ) {
          //window.scrollTo(0, 10000);
          //            settingsc_type  if(pathName==ten_path+'/organization/listing' || pathName==ten_path+'/department/listing' || pathName==ten_path+'/holidays/listing'
          //  || pathName==ten_path+'/points/listing'|| pathName==ten_path+'/job_descripation/listing' || pathName==ten_path+'/saroles/listing'
          //  )
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/payroll") {
        // alert('hii');
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("tax_brackets") > -1 ||
          pathName.indexOf("payroll_line_entry") > -1 ||
          pathName.indexOf("payslip") > -1 ||
          pathName.indexOf("paycode") > -1
        ) {
          //   if(pathName==ten_path+'/organization/listing' || pathName==ten_path+'/department/listing' || pathName==ten_path+'/holidays/listing'
          //  || pathName==ten_path+'/points/listing'|| pathName==ten_path+'/job_descripation/listing' || pathName==ten_path+'/saroles/listing'
          //  )
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/reports") {
        // alert('hii');
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (pathName.indexOf("reports") > -1) {
          //   if(pathName==ten_path+'/organization/listing' || pathName==ten_path+'/department/listing' || pathName==ten_path+'/holidays/listing'
          //  || pathName==ten_path+'/points/listing'|| pathName==ten_path+'/job_descripation/listing' || pathName==ten_path+'/saroles/listing'
          //  )
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/career") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("jobpost") > -1 ||
          pathName.indexOf("careers") > -1 ||
          pathName.indexOf("jobdisclouser") > -1 ||
          pathName.indexOf("job_descripation") > -1 ||
          pathName.indexOf("job_type") > -1 ||
          pathName.indexOf("job_title") > -1 ||
          pathName.indexOf("job_id") > -1
        ) {
          //   if(pathName==ten_path+'/organization/listing' || pathName==ten_path+'/department/listing' || pathName==ten_path+'/holidays/listing'
          //  || pathName==ten_path+'/points/listing'|| pathName==ten_path+'/job_descripation/listing' || pathName==ten_path+'/saroles/listing'
          //  )
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == "/super_admin/index.php/settings") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (pathName == "/super_admin/index.php/organization/listing") {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }
      if (route.path == ten_path + "/shops") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("productcategory") > -1 ||
          pathName.indexOf("product") > -1 ||
          pathName.indexOf("order") > -1 ||
          pathName.indexOf("banner") > -1
        ) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/course") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("course") > -1 ||
          pathName.indexOf("chaptors") > -1
        ) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/groups") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("groups") > -1 ||
          pathName.indexOf("projectgroups") > -1
        ) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/hradmin") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (pathName.indexOf("hradmin") > -1) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }
      if (route.path == ten_path + "/hrLetterListing") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (pathName.indexOf("hrLetterListing") > -1) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen, //|| isHome
          }));
        }
      }

      if (route.path == ten_path + "/projects") {
        // for (let i = 0; i < route.children.length; i++) {
        //   var child = route.children[i];
        //   child.name = T(child.name);

        // }
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("projects") > -1 ||
          pathName.indexOf("projecttasks") > -1
        ) {
          //alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          const isHome = route.containsHome && pathName === "/" ? true : false;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen || isHome,
          }));
        }
      }

      if (route.path == ten_path + "/shifts") {
        for (let i = 0; i < route.children.length; i++) {
          var child = route.children[i];
          child.name = T(child.name);
        }
        if (
          pathName.indexOf("shifts") > -1 ||
          pathName.indexOf("shift_schedular") > -1 ||
          pathName.indexOf("attendance") > -1 ||
          pathName.indexOf("absent") > -1 ||
          pathName.indexOf("leaves") > -1
        ) {
          // if(pathName==ten_path+'/shifts/listing' || pathName==ten_path+'/shift_schedular/listing' || pathName==ten_path+'/shift_schedular/Importschedular'
          //    )
          //  alert('hii1');
          //const isActive = pathName.indexOf(route.path) === 0;
          const isActive = true;
          const isOpen = route.open;
          const isHome = route.containsHome && pathName === "/" ? true : false;
          /// alert(isActive);
          this.setState(() => ({
            [index]: isActive || isOpen || isHome,
          }));
        }
      }
    });

    //  const isActive = pathName.indexOf(route.path) === 0;
  }

  componentDidMount() {
    var pro_package = localStorage.getItem("package");
    var is_super_user = localStorage.getItem("is_super_user");
    this.state.pro_package = pro_package;

    var pro_zone_logo_logo;
    if (pro_package == "1") {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Pro-logo11.png`;
      $("#pro_logo").attr("src", pro_zone_logo_logo);
    } else {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Plus-logo.png`;
      $("#pro_logo").attr("src", pro_zone_logo_logo);
    }

    let ten_path;
    var url = window.location.pathname;

    var str = url.split("/");
    ten_path = "/" + str[1] + "/" + str[2];
    var login_id = localStorage.getItem("login_id");
    var login_type = localStorage.getItem("login_type");
    var pro_package = localStorage.getItem("package");
    this.state.pro_package = pro_package;

    var is_super_user = localStorage.getItem("is_super_user");

    if (
      (login_type == "hr_admin" && is_super_user == "0") ||
      login_type == "super_admin"
    ) {
      fetch(myConstClass.BASE_URL + "user/getProfileInfo/" + login_id)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.setState({ empData: response });
        })
        .catch((err) => console.log(err));
    } else if (login_type == "sub_admin" && is_super_user != "0") {
      fetch(
        myConstClass.BASE_URL + "user/getSuperAdminStaffInfo/" + is_super_user
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.setState({ empData: response });
        })
        .catch((err) => console.log(err));
    } else {
      fetch(myConstClass.BASE_URL + "user/getUserInfoE/" + login_id)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          this.setState({ empData: response });
        })
        .catch((err) => console.log(err));
    }
    
    // Initialize scroll position tracking
    const scroller = this.sidebarRef.current || document.querySelector("#vertical_scroll_sidebar");
    if (scroller) {
      this.scrollPosition = scroller.scrollTop;
      
      // Add MutationObserver to watch for DOM changes that might reset scroll
      const observer = new MutationObserver(() => {
        if (scroller && this.scrollPosition !== undefined && scroller.dataset.preventScrollReset === 'true') {
          const savedScroll = scroller.dataset.scrollTop 
            ? parseInt(scroller.dataset.scrollTop, 10) 
            : this.scrollPosition;
          if (scroller.scrollTop !== savedScroll) {
            scroller.scrollTop = savedScroll;
          }
        }
      });
      
      observer.observe(scroller, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      
      this._mutationObserver = observer;
      
      // Add scroll position watcher to prevent resets
      let lastScrollTop = scroller.scrollTop;
      const scrollWatcher = setInterval(() => {
        if (scroller && this.scrollPosition !== undefined) {
          const currentScroll = scroller.scrollTop;
          // If scroll was reset to 0 but we have a saved position, restore it
          if (scroller.dataset.preventScrollReset === 'true') {
            const savedScroll = scroller.dataset.scrollTop 
              ? parseInt(scroller.dataset.scrollTop, 10) 
              : this.scrollPosition;
            if (currentScroll !== savedScroll) {
              scroller.scrollTop = savedScroll;
            }
          } else if (currentScroll === 0 && this.scrollPosition > 50 && lastScrollTop > 50) {
            scroller.scrollTop = this.scrollPosition;
          }
          lastScrollTop = currentScroll;
        }
      }, 16); // Check every frame (60fps)
      
      // Store interval ID for cleanup
      this._scrollWatcherInterval = scrollWatcher;
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    // Aggressively prevent scroll reset during re-renders
    const scroller = this.sidebarRef.current || document.querySelector("#vertical_scroll_sidebar");
    if (scroller) {
      // Check if we're preventing scroll reset
      if (scroller.dataset.preventScrollReset === 'true') {
        const savedScroll = scroller.dataset.scrollTop 
          ? parseInt(scroller.dataset.scrollTop, 10) 
          : this.scrollPosition;
        
        if (savedScroll !== undefined && scroller.scrollTop !== savedScroll) {
          // Immediately restore scroll position
          scroller.scrollTop = savedScroll;
          this.scrollPosition = savedScroll;
        }
      } else if (this.scrollPosition !== undefined && scroller.scrollTop !== this.scrollPosition) {
        // Only restore if scroll was reset unexpectedly (not by user)
        const scrollDiff = Math.abs(scroller.scrollTop - this.scrollPosition);
        if (scrollDiff > 10 && scroller.scrollTop < this.scrollPosition) {
          // Scroll was reset, restore it
          requestAnimationFrame(() => {
            if (scroller && this.scrollPosition !== undefined) {
              scroller.scrollTop = this.scrollPosition;
            }
          });
        }
      }
    }
  }
  
  componentWillUnmount() {
    // Clean up scroll watcher
    if (this._scrollWatcherInterval) {
      clearInterval(this._scrollWatcherInterval);
    }
    // Clean up mutation observer
    if (this._mutationObserver) {
      this._mutationObserver.disconnect();
    }
  }

  handleScroll = (event) => {
    // Store scroll position for persistence
    const scroller = event.currentTarget || this.sidebarRef.current;
    if (scroller) {
      // Only update if we're not preventing scroll reset
      if (scroller.dataset.preventScrollReset !== 'true') {
        this.scrollPosition = scroller.scrollTop;
        this.setState({ scroll: scroller.scrollTop });
      }
    }
  };


  render() {
    const { sidebar, pro_package } = this.props;
    var admin_id = localStorage.getItem("uname");
    var login_type = localStorage.getItem("login_type");
    const { empData } = this.state;
    let profile_img, profile_name;

    let c_main;
    let pro_zone_logo_logo;
    if (empData && login_type=='hr_admin') {
      if (
        empData.image == "" ||
        (empData.image == null && empData.image != "")
      ) {
        profile_img = myConstClass.DOCS_URL + `img/profile.png`;
        profile_name = empData.first_name + " " + empData.last_name;
      } else {
        profile_img =
          myConstClass.DOCS_URL +
          `uploads/profile_images_hr/` +
          admin_id +
          `/` +
          empData.image;
        profile_name = empData.first_name + " " + empData.last_name;
      }
    } 
    else if (empData) {
      if (
        empData.profile_image == "" ||
        (empData.profile_image == null && empData.profile_image != "")
      ) {
        profile_img = myConstClass.DOCS_URL + `img/profile.png`;
        profile_name = empData.first_name + " " + empData.last_name;
      } else {
        profile_img =myConstClass.DOCS_URL +`/uploads/profile_img/` +empData.profile_image;
        profile_name = empData.first_name + " " + empData.last_name;
      }
    } 
    
    else {
      profile_img = myConstClass.DOCS_URL + `img/profile.png`;
      profile_name = "Name";
    }

    if (pro_package == "1") {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Pro-logo11.png`;
    } else {
      pro_zone_logo_logo =
        myConstClass.SITE_URL + `img/Work-Zone-Plus-logo.png`;
    }

    var admin_id = localStorage.getItem("uname");

    return (
      <nav
        className={classNames(
          "sidebar",
          sidebar.isOpen || "toggled",
          !sidebar.isOnRight || "sidebar-right"
        )}
      >
        <div className="sidebar-content">
          <div
            ref={this.sidebarRef}
            id="vertical_scroll_sidebar"
            onScroll={this.handleScroll}
            style={{
              overflowY: "auto",
              scrollBehavior: "smooth",
              height: "100%",
            }}
          >
            <div>
              <Link to={"/" + myConstClass.TENANT_PAGE_PATH + "dashboard"}>
                {" "}
                <img
                  class="dashboar-plus-logo top_logo"
                  src={logo}
                  style={{ width: "40px", height: "40px" }}
                />{" "}
                <img
                  class="dashboar-plus-logo"
                  src={pro_zone_logo_logo}
                  id="pro_logo"
                  style={{ width: "187px", height: "46px" }}
                />
              </Link>
              <div className="sidebar-user">
                <img
                  src={profile_img}
                  className="img-fluid rounded-circle mb-2"
                  alt="Linda Miller"
                />
                <div className="font-weight-bold">{profile_name}</div>
              </div>
              <ul className="sidebar-nav">
                {routes.map((category, index) => {
                  if (admin_id == 0) {
                    if (category.path == "x") {
                      c_main = "";
                    } else {
                      c_main = category.children ? (
                        <SidebarCategory
                          name={category.name}
                          badgeColor={category.badgeColor}
                          badgeText={category.badgeText}
                          icon={category.icon}
                          to={category.path}
                          isOpen={this.state[index]}
                          onClick={(e) => this.toggle(index, e)}
                        >
                          {category.children.map((route, index) => (
                            //  route.path!='x' ?

                            //                       (
                            <SidebarItem
                              key={index}
                              name={route.name}
                              to={route.path}
                              badgeColor={route.badgeColor}
                              badgeText={route.badgeText}
                            />
                            //   ) :
                            // ''
                          ))}
                        </SidebarCategory>
                      ) : (
                        <SidebarItem
                          name={category.name}
                          to={category.path}
                          icon={category.icon}
                          badgeColor={category.badgeColor}
                          badgeText={category.badgeText}
                        />
                      );
                    }
                  } else {
                    if (category.path == "x") {
                      c_main = "";
                    } else {
                      c_main = category.children ? (
                        <SidebarCategory
                          name={category.name}
                          badgeColor={category.badgeColor}
                          badgeText={category.badgeText}
                          icon={category.icon}
                          to={category.path}
                          isOpen={this.state[index]}
                          onClick={(e) => this.toggle(index, e)}
                        >
                          {category.children.map((route, index) => (
                            <SidebarItem
                              key={index}
                              name={route.name}
                              to={route.path}
                              badgeColor={route.badgeColor}
                              badgeText={route.badgeText}
                            />
                          ))}
                        </SidebarCategory>
                      ) : (
                        <SidebarItem
                          name={category.name}
                          to={category.path}
                          icon={category.icon}
                          badgeColor={category.badgeColor}
                          badgeText={category.badgeText}
                        />
                      );
                    }
                  }
                  return (
                    <React.Fragment key={index}>
                      {category.header ? (
                        <li className="sidebar-header">{category.header}</li>
                      ) : null}

                      {c_main}
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>

            <br />
          </div>
        </div>
      </nav>
    );
  }
}

export default withRouter(
  connect((store) => ({
    sidebar: store.sidebar,
  }))(Sidebar)
);
